import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Polygon } from 'react-google-maps';

import './DeliveryZone.scss';

class DeliveryZone extends Component {
    state = {};

    constructor(props) {
        super(props);

        this.updateDeliveryAreaOnEdit = this.updateDeliveryAreaOnEdit.bind(this);
    }

    getPolygonOptions(isEditModeOn) {
        return {
            strokeColor: '#7d899e',
            fillColor: isEditModeOn ? '#e4dd9f' : '#9eb3d4',
            strokeOpacity: 0.58,
            strokeWeight: 1,
            fillOpacity: 0.5
        };
    }

    bindRef = ref => this.ref = ref;

    componentDidMount() {
        const path = this.ref.getPath();

        window.google.maps.event.addListener(path, 'insert_at', this.updateDeliveryAreaOnEdit);
        window.google.maps.event.addListener(path, 'remove_at', this.updateDeliveryAreaOnEdit);
        window.google.maps.event.addListener(path, 'set_at', this.updateDeliveryAreaOnEdit);
    }

    updateDeliveryAreaOnEdit() {
        const { areaName, zoneIndex, isEditModeOn, updateDeliveryAreaEdit } = this.props;

        if (isEditModeOn) {
            updateDeliveryAreaEdit(areaName, zoneIndex, this.ref);
        }
    }

    render() {
        const { areaName, zoneIndex, paths, isEditModeOn } = this.props;

        return (
            <Polygon
                ref={this.bindRef}
                paths={paths}
                editable={isEditModeOn}
                draggable={isEditModeOn}
                options={this.getPolygonOptions(isEditModeOn)}
                name={areaName + zoneIndex}
            />
        );
    }
}

DeliveryZone.propTypes = {
    areaName: PropTypes.string,
    zoneIndex: PropTypes.number,
    paths: PropTypes.array,
    isEditModeOn: PropTypes.bool,
    updateDeliveryAreaEdit: PropTypes.func,
    
};

export default DeliveryZone;
